import { resolveProductHighlightValue } from './productHighlightAttributes';

export const CATEGORY_SCHEMA_ALIASES = {
  SM: 'smartphone',
  MB: 'smartphone',
  SMARTPHONE: 'smartphone',
  TB: 'tablet',
  TABLET: 'tablet',
  CHG: 'carregador',
  CARREGADOR: 'carregador',
  LP: 'laptop',
  LAPTOP: 'laptop',
  DS: 'desktop',
  DESKTOP: 'desktop',
  CN: 'generic_product',
  CONSOLA: 'generic_product',
  CONSOLE: 'generic_product',
  GA: 'generic_product',
  GAMING: 'generic_product',
  AM: 'generic_product',
  ACESSORIO: 'generic_product',
  ACESSORIOS: 'generic_product',
  ACCESSORY: 'generic_product',
  PAP: 'generic_product',
  PAPELARIA: 'generic_product',
  PC: 'generic_product',
  PECA: 'generic_product',
  PECAS: 'generic_product',
  PART: 'generic_product',
  PARTS: 'generic_product',
  CAR: 'generic_product',
  CARRO: 'generic_product',
  DV: 'generic_product',
  DIVERSOS: 'generic_product',
  SW: 'servidor',
  SERVIDOR: 'servidor',
  AI: 'all_in_one',
  AIO: 'all_in_one',
  ALL_IN_ONE: 'all_in_one',
  'ALL-IN-ONE': 'all_in_one',
  SC: 'monitor_tv',
  MN: 'monitor_tv',
  MONITOR: 'monitor_tv',
  MONITOR_TV: 'monitor_tv',
  TV: 'monitor_tv',
};

export const POS_DESCRIPTION_CONFIGS = {
  smartphone: {
    defaultFields: ['brand', 'model', 'rom', 'rede'],
    fields: [
      { key: 'brand', label: 'Marca' },
      { key: 'model', label: 'Modelo' },
      { key: 'rom', label: 'Armazenamento' },
      { key: 'ram_mobile', label: 'RAM' },
      { key: 'rede', label: 'Rede' },
      { key: 'screen_size', label: 'Ecrã' },
      { key: 'chipset', label: 'Chipset' },
      { key: 'battery_mobile', label: 'Bateria' },
      { key: 'color', label: 'Cor' },
      { key: 'power', label: 'Potência' },
      { key: 'warranty', label: 'Garantia' },
      { key: 'connector', label: 'Conector' },
    ],
  },
  tablet: {
    defaultFields: ['brand', 'model', 'tablet_storage', 'screen_size', 'tablet_connectivity'],
    fields: [
      { key: 'brand', label: 'Marca' },
      { key: 'model', label: 'Modelo' },
      { key: 'tablet_storage', label: 'Armazenamento' },
      { key: 'ram_mobile', label: 'RAM' },
      { key: 'screen_size', label: 'Ecrã' },
      { key: 'tablet_connectivity', label: 'Conectividade' },
      { key: 'chipset', label: 'Chipset' },
      { key: 'os', label: 'Sistema' },
      { key: 'color', label: 'Cor' },
      { key: 'power', label: 'Potência' },
      { key: 'warranty', label: 'Garantia' },
      { key: 'connector', label: 'Conector' },
    ],
  },
  carregador: {
    defaultFields: ['brand', 'model', 'power', 'connector'],
    fields: [
      { key: 'brand', label: 'Marca' },
      { key: 'model', label: 'Modelo' },
      { key: 'power', label: 'Potência' },
      { key: 'connector', label: 'Conector' },
      { key: 'color', label: 'Cor' },
      { key: 'warranty', label: 'Garantia' },
      { key: 'charger_features', label: 'Características' },
    ],
  },
  laptop: {
    defaultFields: ['brand', 'model', 'cpu', 'ram', 'storage_compact', 'screen_size', 'screen_resolution'],
    fields: [
      { key: 'brand', label: 'Marca' },
      { key: 'model', label: 'Modelo' },
      { key: 'cpu', label: 'CPU' },
      { key: 'ram', label: 'RAM' },
      { key: 'storage_compact', label: 'Armazenamento' },
      { key: 'screen_size', label: 'Ecrã' },
      { key: 'screen_resolution', label: 'Resolução' },
      { key: 'gpu', label: 'GPU' },
      { key: 'os', label: 'Sistema' },
      { key: 'color', label: 'Cor' },
      { key: 'power', label: 'Potência' },
      { key: 'warranty', label: 'Garantia' },
      { key: 'connector', label: 'Conector' },
    ],
  },
  desktop: {
    defaultFields: ['brand', 'model', 'cpu', 'ram', 'storage_compact', 'gpu'],
    fields: [
      { key: 'brand', label: 'Marca' },
      { key: 'model', label: 'Modelo' },
      { key: 'cpu', label: 'CPU' },
      { key: 'ram', label: 'RAM' },
      { key: 'storage_compact', label: 'Armazenamento' },
      { key: 'gpu', label: 'GPU' },
      { key: 'os', label: 'Sistema' },
      { key: 'ports', label: 'Portas' },
      { key: 'color', label: 'Cor' },
      { key: 'power', label: 'Potência' },
      { key: 'warranty', label: 'Garantia' },
      { key: 'connector', label: 'Conector' },
    ],
  },
  servidor: {
    defaultFields: ['brand', 'model', 'cpu', 'ram', 'storage_compact'],
    fields: [
      { key: 'brand', label: 'Marca' },
      { key: 'model', label: 'Modelo' },
      { key: 'cpu', label: 'CPU' },
      { key: 'ram', label: 'RAM' },
      { key: 'storage_compact', label: 'Armazenamento' },
      { key: 'ports', label: 'Portas' },
      { key: 'color', label: 'Cor' },
      { key: 'power', label: 'Potência' },
      { key: 'warranty', label: 'Garantia' },
      { key: 'connector', label: 'Conector' },
    ],
  },
  all_in_one: {
    defaultFields: ['brand', 'model', 'cpu', 'ram', 'storage_compact', 'screen_size', 'screen_resolution'],
    fields: [
      { key: 'brand', label: 'Marca' },
      { key: 'model', label: 'Modelo' },
      { key: 'cpu', label: 'CPU' },
      { key: 'ram', label: 'RAM' },
      { key: 'storage_compact', label: 'Armazenamento' },
      { key: 'screen_size', label: 'Ecrã' },
      { key: 'screen_resolution', label: 'Resolução' },
      { key: 'touch', label: 'Touch' },
      { key: 'gpu', label: 'GPU' },
      { key: 'os', label: 'Sistema' },
      { key: 'ports', label: 'Portas' },
      { key: 'wifi', label: 'Wi‑Fi' },
      { key: 'bluetooth', label: 'Bluetooth' },
      { key: 'webcam', label: 'Webcam' },
      { key: 'color', label: 'Cor' },
      { key: 'power', label: 'Potência' },
      { key: 'warranty', label: 'Garantia' },
      { key: 'connector', label: 'Conector' },
    ],
  },
  monitor_tv: {
    defaultFields: ['brand', 'model', 'screen_size', 'screen_resolution', 'panel_type', 'refresh_rate', 'primary_inputs'],
    fields: [
      { key: 'brand', label: 'Marca' },
      { key: 'model', label: 'Modelo' },
      { key: 'screen_size', label: 'Tamanho' },
      { key: 'screen_resolution', label: 'Resolução' },
      { key: 'panel_type', label: 'Painel' },
      { key: 'refresh_rate', label: 'Hz' },
      { key: 'response_time', label: 'Tempo de resposta' },
      { key: 'brightness', label: 'Brilho' },
      { key: 'contrast', label: 'Contraste' },
      { key: 'primary_inputs', label: 'Entradas' },
      { key: 'usb_hub', label: 'USB Hub' },
      { key: 'speakers', label: 'Colunas' },
      { key: 'vesa', label: 'VESA' },
      { key: 'smart_tv', label: 'Smart TV' },
      { key: 'color', label: 'Cor' },
      { key: 'power', label: 'Potência' },
      { key: 'warranty', label: 'Garantia' },
      { key: 'connector', label: 'Conector' },
    ],
  },
  generic_product: {
    defaultFields: ['name', 'brand', 'model', 'part_number'],
    fields: [
      { key: 'name', label: 'Nome' },
      { key: 'brand', label: 'Marca' },
      { key: 'model', label: 'Modelo' },
      { key: 'part_number', label: 'Part Number' },
      { key: 'color', label: 'Cor' },
      { key: 'power', label: 'Potência' },
      { key: 'warranty', label: 'Garantia' },
      { key: 'connector', label: 'Conector' },
    ],
  },
};

const LEGACY_POS_FIELD_ALIASES = {
  charger_watts: 'power',
  connector_type: 'connector',
};

const normalizeCategoryKey = (value = '') => String(value).trim().toUpperCase().replace(/\s+/g, '_');

export const resolveProductSchemaKey = (categoryValue) => CATEGORY_SCHEMA_ALIASES[normalizeCategoryKey(categoryValue)] || null;

export const getPosDescriptionConfig = (categoryValue) => {
  const schemaKey = resolveProductSchemaKey(categoryValue);
  return schemaKey ? POS_DESCRIPTION_CONFIGS[schemaKey] || null : null;
};

export const resolveCatalogPosDescriptionRule = ({
  categoryPrefix,
  categoryId,
  subcategoryId,
  categories = [],
  subcategories = [],
}) => {
  const category = categories.find((item) => item.id === categoryId || item.base_prefix === categoryPrefix) || null;
  const subcategory = subcategories.find((item) => item.id === subcategoryId) || null;

  if (subcategory?.pos_description_enabled) {
    const config = getPosDescriptionConfig(subcategory.prefix || category?.base_prefix || categoryPrefix);
    if (!config) {
      return { enabled: false, fields: [], source: null, config: null };
    }
    const fields = sanitizePosDescriptionFields(subcategory.prefix || category?.base_prefix || categoryPrefix, subcategory.pos_description_fields || []);
    return {
      enabled: true,
      fields: fields.length > 0 ? fields : config.defaultFields,
      source: 'subcategory',
      config,
    };
  }

  if (category?.pos_description_enabled) {
    const config = getPosDescriptionConfig(category.base_prefix || categoryPrefix);
    if (!config) {
      return { enabled: false, fields: [], source: null, config: null };
    }
    const fields = sanitizePosDescriptionFields(category.base_prefix || categoryPrefix, category.pos_description_fields || []);
    return {
      enabled: true,
      fields: fields.length > 0 ? fields : config.defaultFields,
      source: 'category',
      config,
    };
  }

  return {
    enabled: false,
    fields: [],
    source: null,
    config: getPosDescriptionConfig(categoryPrefix),
  };
};

export const sanitizePosDescriptionFields = (categoryValue, fields = []) => {
  const config = getPosDescriptionConfig(categoryValue);
  if (!config) return [];

  const allowed = config.fields.map((field) => field.key);
  return fields
    .map((field) => LEGACY_POS_FIELD_ALIASES[field] || field)
    .filter((field, index, list) => allowed.includes(field) && list.indexOf(field) === index);
};

export const getEffectivePosDescriptionFields = (categoryValue, values = {}) => {
  const config = getPosDescriptionConfig(categoryValue);
  if (!config) return [];
  const overrideFields = sanitizePosDescriptionFields(categoryValue, values.pos_description_fields || []);
  if (values.pos_description_use_override && overrideFields.length > 0) {
    return overrideFields;
  }
  if (values.catalog_pos_description_enabled === false) {
    return [];
  }
  if (values.catalog_pos_description_enabled === true) {
    const catalogFields = sanitizePosDescriptionFields(categoryValue, values.catalog_pos_description_fields || []);
    return catalogFields.length > 0 ? catalogFields : config.defaultFields;
  }
  return config.defaultFields;
};

const readPath = (data, path) => path.reduce((current, segment) => (
  current && typeof current === 'object' ? current[segment] : undefined
), data);

const firstStorageEntry = (specs = {}) => {
  if (Array.isArray(specs.armazenamento) && specs.armazenamento.length > 0) {
    return specs.armazenamento[0] || {};
  }
  if (specs.armazenamento && typeof specs.armazenamento === 'object') {
    return specs.armazenamento;
  }
  return {};
};

const display = (value) => {
  if (value === null || value === undefined || value === false) return null;
  if (Array.isArray(value)) {
    const list = value.map((item) => String(item).trim()).filter(Boolean);
    return list.length > 0 ? list.join(', ') : null;
  }
  if (value === true) return 'Sim';
  const text = String(value).trim();
  return text || null;
};

export const resolvePosDescriptionFieldValue = (product, fieldKey) => {
  const specs = product?.specs || product?.technical_specs || {};
  const storage = firstStorageEntry(specs);

  switch (fieldKey) {
    case 'name':
      return display(product?.name);
    case 'brand':
      return display(product?.brand);
    case 'model':
      return display(product?.model);
    case 'part_number':
      return display(product?.part_number);
    case 'color':
      return resolveProductHighlightValue(product, 'color');
    case 'cpu': {
      const cpuModel = display(readPath(specs, ['cpu', 'modelo']));
      const cpuGen = display(readPath(specs, ['cpu', 'gen']));
      return [cpuModel, cpuGen].filter(Boolean).join(' ') || null;
    }
    case 'ram':
      return display(readPath(specs, ['memoria', 'capacidade'])) || display(readPath(specs, ['memoria', 'ram'])) || display(product?.ram);
    case 'ram_mobile':
      return display(readPath(specs, ['memoria', 'ram'])) || display(readPath(specs, ['memoria', 'capacidade']));
    case 'storage_compact': {
      const capacity = display(storage.capacidade) || display(product?.storage) || display(product?.rom);
      const type = display(storage.tipo);
      return [capacity, type].filter(Boolean).join(' ') || null;
    }
    case 'screen_size':
      return display(readPath(specs, ['ecra', 'polegadas']));
    case 'rom':
      return display(readPath(specs, ['memoria', 'rom']));
    case 'tablet_storage':
      return display(readPath(specs, ['memoria', 'armazenamento']));
    case 'screen_resolution':
      return display(readPath(specs, ['ecra', 'resolucao']));
    case 'chipset':
      return display(readPath(specs, ['processador', 'chipset'])) || display(readPath(specs, ['cpu', 'modelo']));
    case 'rede':
      return display(readPath(specs, ['conectividade', 'rede']));
    case 'tablet_connectivity':
      return display(readPath(specs, ['conectividade', 'celular'])) || (readPath(specs, ['conectividade', 'wifi']) ? 'WiFi' : null);
    case 'battery_mobile': {
      const value = display(readPath(specs, ['bateria', 'capacidade_mah']));
      return value ? `${value}mAh` : null;
    }
    case 'touch':
      return readPath(specs, ['ecra', 'tactil']) ? 'Touch' : null;
    case 'gpu':
      return display(readPath(specs, ['grafica', 'gpu2'])) || display(readPath(specs, ['grafica', 'gpu1']));
    case 'os':
      return display(readPath(specs, ['sistema', 'os']));
    case 'ports':
      return display(readPath(specs, ['conectividade', 'inputs']));
    case 'wifi':
      return display(readPath(specs, ['conectividade', 'wifi']));
    case 'bluetooth':
      return display(readPath(specs, ['conectividade', 'bluetooth']));
    case 'webcam':
      return display(readPath(specs, ['sistema', 'webcam'])) || display(readPath(specs, ['conectividade', 'webcam']));
    case 'warranty': {
      return resolveProductHighlightValue(product, 'warranty');
    }
    case 'charger_watts':
    case 'power':
      return resolveProductHighlightValue(product, 'power');
    case 'connector_type':
    case 'connector':
      return resolveProductHighlightValue(product, 'connector');
    case 'charger_features': {
      const features = [];
      if (readPath(specs, ['saida', 'pd'])) features.push('PD');
      if (readPath(specs, ['saida', 'qc'])) features.push('QC');
      if (readPath(specs, ['saida', 'gan'])) features.push('GaN');
      return features.length > 0 ? features.join('/') : null;
    }
    case 'panel_type':
      return display(readPath(specs, ['ecra', 'tipo_painel']));
    case 'refresh_rate': {
      const value = display(readPath(specs, ['ecra', 'hz']));
      return value && !value.endsWith('Hz') ? `${value}Hz` : value;
    }
    case 'response_time': {
      const value = display(readPath(specs, ['ecra', 'tempo_resposta']));
      return value && !value.endsWith('ms') ? `${value}ms` : value;
    }
    case 'brightness': {
      const value = display(readPath(specs, ['ecra', 'brilho']));
      return value && !value.endsWith('nits') ? `${value} nits` : value;
    }
    case 'contrast':
      return display(readPath(specs, ['ecra', 'contraste']));
    case 'primary_inputs':
      return display(readPath(specs, ['conectividade', 'inputs']));
    case 'usb_hub':
      return display(readPath(specs, ['conectividade', 'usb_hub']));
    case 'speakers': {
      const watts = display(readPath(specs, ['audio', 'watts']));
      if (watts) return `Colunas ${watts}W`;
      return readPath(specs, ['audio', 'colunas']) ? 'Colunas' : null;
    }
    case 'vesa':
      return display(readPath(specs, ['suporte', 'vesa']));
    case 'smart_tv': {
      if (!readPath(specs, ['smart', 'is_smart'])) return null;
      const system = display(readPath(specs, ['smart', 'sistema']));
      return system ? `Smart TV ${system}` : 'Smart TV';
    }
    default:
      return null;
  }
};

export const buildPosDescriptionPreview = (product, categoryValue = product?.category) => {
  const baseName = resolvePosDescriptionFieldValue(product, 'name');
  const complements = getEffectivePosDescriptionFields(categoryValue, product)
    .filter((fieldKey) => fieldKey !== 'name')
    .map((fieldKey) => resolvePosDescriptionFieldValue(product, fieldKey))
    .filter(Boolean);

  const parts = [baseName, ...complements].filter(Boolean);
  return parts.length > 0 ? parts.join(', ') : '';
};